import React from 'react';
import moment from 'moment';
import {ListGroupItem, Badge} from 'reactstrap';
import { appHelpers } from '../../_helpers';

import ToolTipItem from '../utils/tooltip';

import IconMdAirplanemodeActive from 'react-icons/lib/md/airplanemode-active';
import IconMdDate from 'react-icons/lib/md/date-range';
import IconAirlineSeat from 'react-icons/lib/md/airline-seat-recline-normal';
import IconDollar from 'react-icons/lib/fa/dollar';

// window.moment = moment;

const Manifest = ({manifest, showManifest, manifestKey, id}) => {
    return (
        <ListGroupItem className="">
            <blockquote className="blockquote" style={{ width: '100%!important'}}>
                <h6 className="mb-2"><IconMdAirplanemodeActive size="18" color="#43a8df"/> {`${manifest.AirlineName} - ${manifest.FlightNumber} (${manifest.FlightRoute})`}</h6>
                <footer style={{ paddingLeft: '20px'}} className="blockquote-footer pull-left">
                    <span>
                        <IconMdDate size="18" color="#202021"/><ToolTipItem key={manifestKey + 'flightDate'} title={moment((manifest.DepartureDate).split('T')[0]).format('MMM Do YYYY')} content='Date of Flight' id={ id + 'flightDate'}/> | <ToolTipItem key={manifestKey + 'submittedDate'} title={moment((manifest.DateSubmitted).split('T')[0]).format('MMM Do YYYY')} content='Submitted Date' id={ id +  'submittedDate'}/>
                    </span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>
                        <IconAirlineSeat size="18" color="#0a3150"/>
                        <ToolTipItem key={manifestKey + 'paxCount'} title={appHelpers.numberWithCommasOnly(manifest.PassengersCount)} content='Total Passengers' id={ id + 'paxCount'}/>
                    </span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>
                        <span style={{ color: "#00c853"}}>&#8358;</span><ToolTipItem key={manifestKey + 'TSCNaira'} title={appHelpers.numberWithCommas(manifest.TSCAmountNGN)} content='TSC Naira' id={ id +  'TSCNaira'}/> | <IconDollar size="18" color="#00c853"/><ToolTipItem key={manifestKey + 'TSCDollar'} title={appHelpers.numberWithCommas(manifest.TSCAmountUSD)} content='TSC Dollar' id={ id + 'TSCDollar'}/>
                    </span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Badge className='pointer' key={manifest.ManifestId + 'badge'} onClick={(e) => showManifest(manifest)} color="default">More details</Badge>
                </footer>
            </blockquote>
        </ListGroupItem>
    );
};

export default Manifest;



// WEBPACK FOOTER //
// ./src/views/search/manifest-record.js